export default class AbstractAnalyticsInjector {
  constructor(app) {
    this.app = app
    this.installed = false
    this.scriptLoaded = false
    this.listenersCreated = false
    this.accountId = null
  }

  getEvents() {
    return {}
  }

  load(id, config, head) {
    throw new Error('You must override load() method.')
  }

  init(config) {
    throw new Error('You must override init() method.')
  }

  handleEvent(event, externalEvent, payload) {
    throw new Error('You must override handleEvent() method.')
  }

  install(id, config) {
    return new Promise((resolve, reject) => {
      if (this.installed) {
        return resolve()
      }

      this.loadScript(id, config)
        .then(() => {
          this.accountId = id

          if (!this.init(config)) {
            return reject({
              message: 'Script was loaded but plugin was not able to initialize.',
            })
          }

          this.createListeners()

          return resolve()
        })
        .catch(err => reject(err))
    })
  }

  loadScript(id, config) {
    return new Promise((resolve, reject) => {
      if (this.scriptLoaded) {
        return resolve()
      }

      const head = document.head || document.getElementsByTagName('head')[0];

      if (!head) {
        return reject({ message: 'Head tag was not found. '})
      }

      this.load(id, config, head)
        .then(() => {
          this.scriptLoaded = true
          resolve()
        })
        .catch(err => reject(err))
    })
  }

  createListeners() {
    if (this.listenersCreated) {
      return
    }

    const events = this.getEvents()

    if (typeof events !== 'object' || !Object.keys(events).length) {
      return
    }

    for (let event in events) {
      if (!events.hasOwnProperty(event)) {
        continue
      }

      this.app
        .sharedEventBus
        .$on(event, payload => this.handleEvent(event, events[event], payload))
    }
  }
}
